import { Auth0Provider } from '@auth0/auth0-react';
import type { Auth0ProviderOptions } from '@auth0/auth0-react';

// auth0-config.js
export const auth0Config: Auth0ProviderOptions = {
  domain: process.env.REACT_APP_AUTH_DOMAIN,
  clientId: process.env.REACT_APP_AUTH_CLIENT,
  authorizationParams: {
    connection: 'trained-connection',
    redirect_uri: window.location.origin,
    audience: `https://${process.env.REACT_APP_AUTH_DOMAIN}/api/v2/`,
    scope: 'read:current_user update:current_user_metadata offline_access',
  },
};

type RealProviderProps = {
  children: React.ReactNode;
};

export { useAuth0 as useRealContext } from '@auth0/auth0-react';

export const RealProvider: React.FC<RealProviderProps> = ({ children }) => {
  return (
    <Auth0Provider
      useRefreshTokens
      domain={auth0Config.domain}
      cacheLocation="localstorage"
      clientId={auth0Config.clientId}
      authorizationParams={auth0Config.authorizationParams}
    >
      {children}
    </Auth0Provider>
  );
};
